import { createFileRoute } from '@tanstack/react-router';

import { DeviceProfileTab } from './profile';

export const Route = createFileRoute('/_staff/devices/$id/_layout/')({
  component: DeviceDetailIndex,
});

function DeviceDetailIndex() {
  return <DeviceProfileTab />;
}
